<template>
    <div>
        <v-snackbar
            v-model="snackbar"
            :timeout="3000"
            :color="snackbarColor"
            :text="snackbarTextProp"
            :outlined="snackbarOutlined"
            top
        >
            {{ snackbarText }}

            <template v-slot:action="{ attrs }">
                <v-btn
                    :color="snackbarColor"
                    fab
                    x-small
                    elevation="1"
                    v-bind="attrs"
                    @click="snackbar = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
        <v-row>
            <v-col>
                <h4>Confirmed Hours</h4>
            </v-col>
        </v-row>
        <v-row class="mx-auto">
            <v-form>
                <v-row>
                    <v-col
                        cols="12"
                        md="2"
                        sm="6"
                    >
                        <v-menu
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="dateStart"
                                    label="Date Start"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="dateStart"
                                @input="menu = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col
                        cols="12"
                        md="2"
                        sm="6"
                    >
                        <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="dateEnd"
                                    label="Date End"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="dateEnd"
                                @input="menu2 = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col
                        class="d-flex"
                        cols="12"
                        md="2"
                        sm="4"
                    >
                        <v-select
                            v-model="program"
                            :items="units"
                            item-text="Name"
                            item-value="_id"
                            label="Programs"
                            dense
                            multiple
                            outlined
                            clearable
                            @change="programChange"
                        >
                            <template v-slot:prepend-item>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-text-field 
                                            v-model="searchTerm" 
                                            placeholder="Search" 
                                            @input="searchUnits"
                                            clearable
                                        >
                                        </v-text-field>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                                <v-list-item
                                    ripple
                                    @mousedown.prevent
                                    @click="toggle"
                                >
                                    <v-list-item-action>
                                        <v-icon :color="program.length > 0 ? 'indigo darken-4' : ''">
                                            {{ icon }}
                                        </v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            Select All
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class=""></v-divider>
                                <v-list>
                                    <v-list-group
                                        prepend-icon=""
                                    >
                                        <template v-slot:activator>
                                            <v-list-item-content>
                                                <v-list-item-title v-text="'Select By State'"></v-list-item-title>
                                            </v-list-item-content>
                                        </template>
                                        <v-list-item
                                            ripple
                                            @mousedown.prevent
                                            @click="toggleUtahPrograms"
                                        >
                                            <v-list-item-action>
                                                <v-icon :color="utahPrograms.length > 0 ? 'indigo darken-4' : ''">
                                                    {{ filterUtahIcon }}
                                                </v-icon>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                <v-list-item-title v-text="'Utah Programs'"></v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item
                                            ripple
                                            @mousedown.prevent
                                            @click="toggleNevadaPrograms"
                                        >
                                            <v-list-item-action>
                                                <v-icon :color="nevadaPrograms.length > 0 ? 'indigo darken-4' : ''">
                                                    {{ filterNevadaIcon}}
                                                </v-icon>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                <v-list-item-title v-text="'Nevada Programs'"></v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-group>
                                </v-list>
                                <v-divider class="mb-2"></v-divider>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index < 2">
                                    <span>{{ item.Name }}</span>
                                </v-chip>
                                <span
                                    v-if="index === 2"
                                    class="grey--text text-caption"
                                >
                                    (+{{ program.length - 2 }} others)
                                </span>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col
                        class="d-flex"
                        cols="12"
                        md="2"
                        sm="4"
                    >
                        <v-select
                            v-model="position"
                            :items="droles"
                            label="Positions"
                            dense
                            outlined
                            clearable
                        ></v-select>
                    </v-col>
                    <v-col
                        class="d-flex"
                        cols="12"
                        md="2"
                        sm="4"
                    >
                        <v-select
                            v-model="employee"
                            :items="employees"
                            label="Employees"
                            item-text="Name"
                            item-value="_id"
                            dense
                            outlined
                            clearable
                        ></v-select>
                    </v-col>
                    <v-col
                        class="d-flex"
                        cols="12"
                        lg="2"
                        md="4"
                        sm="6"
                    >
                        <v-btn 
                            class="me-2"
                            color="success" 
                            @click="getConfirmedPayroll()"
                        >
                            Apply
                        </v-btn>
                        <!--<v-btn color="success" @click="downloadPayroll()">
                        Download
                        </v-btn>
                        -->
                        <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    color="primary"
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    Download
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item link @click="downloadPayroll()">
                                    <v-list-item-title>Payroll Review</v-list-item-title>
                                </v-list-item>
                                <v-list-item link @click="downloadWorkstream()">
                                    <v-list-item-title>Workstream Template</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-col>
                </v-row>
            </v-form>
        </v-row>
        <v-row class="mx-auto">
            <v-divider class="mt-4"></v-divider>
        </v-row>
        <v-row class="mt-auto">
            <v-col cols="12" md="4" sm="4">
                <v-checkbox
                    v-model="SplitOvernight"
                    label="Split Overnight"
                    @click="getPayrollSplit()"
                ></v-checkbox>
            </v-col>
            <v-col cols="12" md="8" sm="9">
                <v-radio-group v-model="radioGroup" row>
                    <v-radio
                        label="Don't Group"
                        :value="0"
                        @click="getConfirmedPayroll()"
                    ></v-radio>
                    <v-radio
                        label="Group By Employee"
                        :value="1"
                        @click="groupPayroll()"
                    ></v-radio>
                </v-radio-group>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="timesheets"
                    :loading="isLoadingConfirmedPayroll"
                    loading-text="Loading... Please wait"
                    class="elevation-1"
                >
                    <template
                        v-slot:header="{  }"
                    >
                        <thead>
                            <tr>
                                <th 
                                    v-for="(header, i) in upperHeader"
                                    :key="i"
                                >
                                    {{ header.text }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td 
                                    v-for="(header, i) in upperHeader"
                                    :key="i"
                                >
                                    {{ header.value }}
                                </td>
                            </tr>
                        </tbody>
                    </template>
                    <template v-slot:item.cost="{ item }">
                        <v-text-field
                            v-model="editedItem.cost"
                            v-if="item.id === editedItem.id"
                            clearable
                            class="edited-field"
                        >
                        </v-text-field>
                        <span v-else>
                            {{ item.cost }}
                        </span>
                    </template>
                    <template v-slot:item.actualClockIn="{ item }">
                        <v-text-field
                            v-model="editedItem.actualClockIn"
                            v-if="item.id === editedItem.id"
                            clearable
                            class="edited-field"
                        >
                        </v-text-field>
                        <span v-else>
                            {{ item.actualClockIn }}
                        </span>
                    </template>
                    <template v-slot:item.actualClockOut="{ item }">
                        <v-text-field
                            v-model="editedItem.actualClockOut"
                            v-if="item.id === editedItem.id"
                            clearable
                            class="edited-field"
                        >
                        </v-text-field>
                        <span v-else>
                            {{ item.actualClockOut }}
                        </span>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <div v-if="item.id === editedItem.id" class="d-flex justify-space-between">
                            <v-icon color="red" class="" @click="closeItem">
                                mdi-close
                            </v-icon>
                            <v-icon color="green" class="" @click="saveItem" :loading="isLoadingSaveEditButton" :disabled="isLoadingSaveEditButton">
                                mdi-content-save
                            </v-icon>
                        </div>
                        <div v-else>
                            <v-icon small color="green" class="mr-2" @click="editItem(item)">
                                mdi-pencil
                            </v-icon>
                        </div>
                    </template>

                </v-data-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>

import axios from 'axios';
import moment from "moment";


import {mapGetters, mapMutations, mapState} from "vuex";
import {setUserTz} from "../../../../utils/timezone";

const url = require("../../../client_config/config").url;

export default {


    data: () => ({
        menu: false,
        menu2: false,
        headers: [

            /*{
              text: 'UserId',
              align: 'start',
              sortable: false,
              value: 'UserId',
            },
            */
            {text: 'Employee', value: 'employee'},
            //{ text: 'EID', value: 'eid' },
            {text: 'Date', value: 'date'},
            {text: 'Shift Title', value: 'shiftTitle'},
            {text: 'Position', value: 'position'},
            {text: 'Rate', value: 'rate'},
            {text: 'Ratecard', value: 'rateCard'},
            {text: 'Date', value: 'date'},
            {text: 'Regular (hrs)', value: 'regular'},
            {text: 'Special', value: 'special'},
            {text: 'Overtime (hrs)', value: 'overtime'},
            {text: 'Total (hrs)', value: 'total'},
            {text: 'Tips', value: 'tip'},
            {text: 'Cost', value: 'cost'},
            {text: "Actions", value: "actions", sortable: false},
        ],
        upperHeader: [
            {text: '', value: ''},
            {text: '', value: ''},
            {text: '', value: ''},
            {text: '', value: ''},
            {text: '', value: ''},
            {text: '', value: ''},
            {text: '', value: ''},
            {text: 'Overall Regular (hrs)', value: 0,},
            {text: '', value: '',},
            {text: 'Overall Overtime (hrs)', value: 0,},
            {text: 'Overall Total (hrs)', value: 0,},
            {text: '', value: '',},
            {text: 'Overall Cost', value: 0,},
            {text: "", value: "",},
        ],
        units: [],
        unitsCopy: [],
        employees: [],
        state: localStorage.getItem('userState'),
        userRole: localStorage.getItem('userRole'),
        //dateStart:"",
        //dateEnd: "",
        employee: "",
        position: "",
        program: [],
        utahPrograms: [],
        nevadaPrograms: [],
        timesheets: [],
        radioGroup: 0,
        SplitOvernight: false,
        editedIndex: -1,
        editedItem: {
            id: 0,
            cost: '',
        },
        defaultItem: {
            id: 0,
            cost: '',
        },
        searchTerm: "",
        selectedUnits: [],
        options: {},
        totalData: 0,
        isLoadingConfirmedPayroll: false,

        snackbar: false,
        snackbarText: "",
        snackbarColor: "",
        snackbarTextProp: false,
        snackbarOutlined: false,

        isLoadingSaveEditButton: false,
    }),

    async created() {
        await this.getUnits();
        await this.getEmployees();
    },

    computed: {
        ...mapState({
            droles: 'userRoles',
        }),
        ...mapGetters({
            getUserTimezone: "timezones/getUserTimezone",
            getDefaultTz: "timezones/getDefaultTz",
        }),

        userTimezone() {
            const data = {
                userTimezone: this.getUserTimezone,
                defaultTz: this.getDefaultTz,
            };
            return setUserTz(data);
        },

        /*
        filteredEmployee(){
          return this.employees.filter(user => user.Role ===  this.position && user.Program.includes(this.program))
        },
        */

        dateStart: {
            get() {
                return this.$store.state.payroll.dateStart;
            },
            set(val) {
                this.setDateStart(val);
            }
        },

        dateEnd: {
            get() {
                return this.$store.state.payroll.dateEnd;
            },
            set(val) {
                this.setDateEnd(val);
            }
        },

        likesAllUnits() {
            return this.program.length === this.units.length
        },

        likesSomeUnits() {
            return this.program.length > 0 && !this.likesAllUnits
        },

        icon() {
            if (this.likesAllUnits) return 'mdi-close-box'
            if (this.likesSomeUnits) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        
        /*--------------------- Select All Utah programs -----------------*/
        selectedAllUtahPrograms() {
            let sum = 0
            
            this.units.forEach(item => {
                return item.State == "Utah" ? sum++ : sum;
            })
            
            return this.program.length === sum
        },
        filterUtahIcon() {
            if (this.selectedAllUtahPrograms) return 'mdi-close-box'
            return 'mdi-checkbox-blank-outline'
        },
        /*--------------------- ---------------------------- -----------------*/
        /*---------------------- Select All Nevada programs ------------------*/
        selectedAllNevadaPrograms() {
            let sum = 0

            this.units.forEach(item => {
                return item.State == "Nevada" ? sum++ : sum;
            })
            
            return this.program.length === sum
        },
        filterNevadaIcon() {
            if (this.selectedAllNevadaPrograms) return 'mdi-close-box'
            return 'mdi-checkbox-blank-outline'
        },
        /*--------------------- ---------------------------- -----------------*/
    },

    watch: {
        // options: {
        //     handler() {
        //         this.getConfirmedPayroll();
        //     },
        //     deep: true,
        // },
    },

    mounted() {
        // this.getConfirmedPayroll();
    },

    methods: {
        ...mapMutations({
            setDateStart: "payroll/SET_DATE_START",
            setDateEnd: "payroll/SET_DATE_END",
        }),

        searchUnits(e) {
            console.log(e);
            //console.log(this.units);

            if (!this.searchTerm) {
                this.units = this.unitsCopy;
            } else {
                this.units = this.unitsCopy.filter((item) => {
                    return this.searchTerm.toLowerCase().split(' ').every(v => item.Name.toLowerCase().includes(v))
                });
            }
        },

        toggle() {
            this.$nextTick(() => {
                if (this.likesAllUnits) {
                    this.utahPrograms = []
                    this.nevadaPrograms = []
                    this.program = []
                } else {
                    this.program = this.units.slice()
                    this.program = this.program.map(item => item._id)
                }
            })
        },

        toggleUtahPrograms() {
            this.$nextTick(() => {
                if (this.selectedAllUtahPrograms) {
                    this.utahPrograms = []
                    this.program = []
                } else {
                    this.utahPrograms = this.units.filter(item => item.State == "Utah")
                    this.program = this.utahPrograms
                    this.program = this.program.map(item => item._id)
                }
            })
        },
        toggleNevadaPrograms() {
            this.$nextTick(() => {
                if (this.selectedAllNevadaPrograms) {
                    this.nevadaPrograms = []
                    this.program = []
                } else {
                    this.nevadaPrograms = this.units.filter(item => item.State == "Nevada")
                    this.program = this.nevadaPrograms
                    this.program = this.program.map(item => item._id)
                }
            })
        },

        programChange() {
            this.units = this.unitsCopy;
        },

        getUnits: async function () {
            await axios.get(`${url}/units`).then(async res => {
                res.data.units.forEach(item => {
                    this.units.push(item)
                })
            });

            this.unitsCopy = [...this.units];
        },

        async getEmployees() {
            axios.get(`${url}/users/state/${this.state}`).then(res => {
                this.employees = res.data.users;
            });
        },

        getConfirmedPayroll() {

            this.isLoadingConfirmedPayroll = true;

            if (this.employee == null || this.employee === "") {
                this.employee = "All";
            }
            this.headers = [
                /*
                {
                  text: 'UserId',
                  align: 'start',
                  sortable: false,
                  value: 'UserId',
                },
                */
                {text: 'Employee', value: 'employee'},
                {text: 'PaychexID', value: 'PaychexID'},
                //{ text: 'EID', value: 'eid' },
                {text: 'Shift Title', value: 'shiftTitle'},
                {text: 'Position', value: 'position'},
                {text: 'Program', value: 'program'},
                {text: 'Client', value: 'ClientName'},
                {text: 'Rate', value: 'rate'},
                {text: 'Ratecard', value: 'rateCard'},
                {text: 'Date', value: 'date'},
                {text: 'Scheduled Start Time', value: 'scheduleClockIn'},
                {text: 'Scheduled End Time', value: 'scheduleClockOut'},
                {text: 'Actual Clock In Time', value: 'actualClockIn'},
                {text: 'Actual Clock Out Time', value: 'actualClockOut'},
                {text: 'Rounded Clock In Time', value: 'roundedClockIn'},
                {text: 'Rounded Clock Out Time', value: 'roundedClockOut'},
                {text: 'Regular (hrs)', value: 'regular'},
                {text: 'Special', value: 'special'},
                {text: 'Overtime (hrs)', value: 'overtime'},
                {text: 'Total (hrs)', value: 'total'},
                {text: 'Tips', value: 'tip'},
                {text: 'Cost', value: 'cost'},
                {text: "Actions", value: "actions", sortable: false, width: "100px", align: "center"},
            ];
            this.upperHeader = [
                {text: '', value: ''},
                {text: '', value: ''},
                {text: '', value: ''},
                {text: '', value: ''},
                {text: '', value: ''},
                {text: '', value: ''},
                {text: '', value: ''},
                {text: '', value: ''},
                {text: '', value: ''},
                {text: '', value: ''},
                {text: '', value: ''},
                {text: '', value: ''},
                {text: '', value: ''},
                {text: '', value: ''},
                {text: '', value: ''},
                {text: 'Overall Regular (hrs)', value: 0},
                {text: '', value: ''},
                {text: 'Overall Overtime (hrs)', value: 0},
                {text: 'Overall Total (hrs)', value: 0},
                {text: '', value: ''},
                {text: 'Overall Cost', value: 0},
                {text: "", value: "",},
            ];

            const {page, itemsPerPage} = this.options;

            let req_body = {
                Program: this.program,
                Position: this.position,
                Employee: this.employee,
                DateStart: this.dateStart,
                DateEnd: this.dateEnd,
                GroupEmployee: this.radioGroup,
                Timezone: this.userTimezone,
                page: page,
                size: itemsPerPage,
                userState: this.state,
            };

            this.timesheets = [];

            axios.post(`${url}/payroll/timesheets`, req_body).then(res => {

                this.isLoadingConfirmedPayroll = false;
                this.totalData = res.data.total;
                let count = 1;
                res.data.timesheets.forEach((value) => {

                    let actualClockIn = "";
                    let actualClockOut = "";

                    value.scheduleClockIn = moment(new Date(value.ScheduleIn)).format("hh:mm a");
                    value.scheduleClockOut = moment(new Date(value.ScheduleOut)).format("hh:mm a");

                    value.ScheduleIn = (value.ScheduleIn[0] == undefined ? value.ClockIn : value.ScheduleIn[0])
                    value.date = moment(new Date(value.ScheduleIn)).tz(this.userTimezone).format("YYYY-MM-DD");

                    value.position = value.EmployeePosition[0];
                    value.program = this.findProgram(value.Program[0]);
                    value.employee = value.EmployeeName[0];
                    value.UserId = value._id.employeeID;

                    value.Rate = (value.Rate[0] == undefined ? 0 : value.Rate[0]);
                    value.rate = value.Rate !== "n/a" ? "$" + value.Rate : "n/a";

                    value.actualClockIn = (value.ClockIn == "") ? "" : moment(new Date(value.ClockIn)).format("hh:mm a");
                    value.actualClockOut = (value.ClockOut == "") ? "" : moment(new Date(value.ClockOut)).format("hh:mm a");

                    actualClockIn = this.getRoundedDate(15, new Date(value.ClockIn));
                    actualClockOut = (value.ClockOut == "" || value.ClockOut.length == 0 || value.ClockOut == null) ? "" : this.getRoundedDate(15, new Date(value.ClockOut));

                    value.roundedClockIn = moment(new Date(actualClockIn)).format("hh:mm a");
                    value.roundedClockOut = (actualClockOut == "") ? "" : moment(new Date(actualClockOut)).format("hh:mm a");

                    let getRoundedHours = moment.duration(moment(new Date(value.date + " " + value.roundedClockOut)).diff(moment(new Date(value.date + " " + value.roundedClockIn) ))).asHours()
                    let rounded = null;

                    if (getRoundedHours < 0) {
                        rounded = moment.duration(moment(new Date(value.date + " " + value.roundedClockOut)).add(1, 'days').diff(moment(new Date(value.date + " " + value.roundedClockIn) ))).asHours()
                        
                    } else {
                        rounded = getRoundedHours
                    }

                    value.regular = (rounded > 8) ? 8 : rounded;
                    this.upperHeader[15].value = this.upperHeader[15].value + parseFloat(value.regular); // sums the regular hours

                    value.overtime = (rounded > 8) ? rounded - 8 : 0;
                    this.upperHeader[17].value = this.upperHeader[17].value + parseFloat(value.overtime); // sums the overtime hours

                    value.total = rounded;
                    this.upperHeader[18].value = this.upperHeader[18].value + parseFloat(value.total); // sums the total hours

                    let parsedCost = (parseFloat(value.total)) * (parseFloat(value.Rate) || 0);
                    value.cost = "$" + parsedCost.toFixed(2);
                    this.upperHeader[20].value = this.upperHeader[20].value + parseFloat(parsedCost.toFixed(2)); // sums the cost
                    value.id = count++;

                    this.timesheets.push(value);

                    // Sort by Program (Ascending order)
                    this.timesheets.sort((a, b) => {
                        if (a.program < b.program) {
                            return -1;
                        }
                        if (a.program > b.program) {
                        return 1;
                        }
                    
                        // names must be equal
                        return 0;
                    })
                });
            }).finally(() => {
                this.upperHeader[15].value = this.upperHeader[15].value.toFixed(2);
                this.upperHeader[17].value = this.upperHeader[17].value.toFixed(2);
                this.upperHeader[18].value = this.upperHeader[18].value.toFixed(2);
                this.upperHeader[20].value = this.upperHeader[20].value.toFixed(2);
            });

            // USAGE //

            // Round existing date to 5 minutes
            //getRoundedDate(15, new Date()); // 2018-01-26T00:45:00.000Z

            // Get current time rounded to 30 minutes
            //getRoundedDate(30); // 2018-01-26T00:30:00.000Z
        },

        getRoundedDate(minutes, d = new Date()) {
            let ms = 1000 * 60 * minutes; // convert minutes to ms
            let roundedDate = new Date(Math.round(d.getTime() / ms) * ms);
            return roundedDate
        },

        findProgram(programID) {
            return this.units.filter(unit => {
                if (unit._id == programID) return unit
            }).map(value => {
                return value.Name
            });
        },


        async groupPayroll() {
            this.isLoadingConfirmedPayroll = true;
            let timesheets = [];

            if (this.employee == null || this.employee == "") {
                this.employee = "All";
            }

            this.headers = [
                /*
                {
                  text: 'UserId',
                  align: 'start',
                  sortable: false,
                  value: 'UserId',
                },
                */
                {text: 'Employee', value: 'employee'},
                {text: 'PaychexID', value: 'PaychexID'},
                {text: 'Shift Title', value: 'shiftTitle'},
                {text: 'Position', value: 'position'},
                {text: 'Program', value: 'program'},
                {text: 'Client', value: 'ClientName'},
                {text: 'Ratecard', value: 'rateCard'},
                {text: 'Start Date', value: 'startTime'},
                {text: 'End Date', value: 'endTime'},
                {text: 'Regular (hrs)', value: 'regular'},
                {text: 'Special', value: 'special'},
                {text: 'Overtime (hrs)', value: 'overtime'},
                {text: 'Total (hrs)', value: 'total'},
                {text: 'Tips', value: 'tip'},
                {text: 'Cost', value: 'cost'},
            ];
            this.upperHeader = [
                {text: '', value: ''},
                {text: '', value: ''},
                {text: '', value: ''},
                {text: '', value: ''},
                {text: '', value: ''},
                {text: '', value: ''},
                {text: '', value: ''},
                {text: '', value: ''},
                {text: '', value: ''},
                {text: 'Overall Regular (hrs)', value: 0},
                {text: '', value: ''},
                {text: 'Overall Overtime (hrs)', value: 0},
                {text: 'Overall Total (hrs)', value: 0},
                {text: '', value: ''},
                {text: 'Overall Cost', value: 0},
            ];

            var req_body = {
                Program: this.program,
                Position: this.position,
                Employee: this.employee,
                DateStart: this.dateStart,
                DateEnd: this.dateEnd,
                GroupEmployee: this.radioGroup,
                Timezone: this.userTimezone,
            };

            if (this.radioGroup == 0) {
                this.getConfirmedPayroll();
            } else {

                try {
                    await axios.post(`${url}/payroll/timesheets`, req_body).then(res => {
                        this.timesheets = [];
                        res.data.timesheets.forEach((value) => {
                            let actualClockIn = "";
                            let actualClockOut = "";
                            // let totalTimeFull = 0;

                            value.ScheduleIn = (value.ScheduleIn[0] == undefined ? value.ClockIn : value.ScheduleIn[0]);
                            let date = moment(new Date(value.ScheduleIn)).tz(this.userTimezone).format("YYYY-MM-DD");

                            value.employee = value.EmployeeName;
                            value.UserId = value._id.employeeID;
                            value.position = value.EmployeePosition;
                            value.program = value.ProgramName;

                            value.Rate = (value.Rate == undefined ? 0 : value.Rate);
                            value.rate = value.Rate !== "n/a" ? "$" + value.Rate : "n/a";

                            value.startTime = moment(new Date(this.dateStart)).format("DD MMM YYYY");
                            value.endTime = moment(new Date(this.dateEnd)).format("DD MMM YYYY");

                            actualClockIn = this.getRoundedDate(15, new Date(value.ClockIn));
                            if (value.ClockOut != null) {
                                actualClockOut = this.getRoundedDate(15, new Date(value.ClockOut))
                            } else {
                                actualClockOut = ""
                            }
                            // actualClockOut = (value.ClockOut == "" || value.ClockOut.length == 0 || value.ClockOut == null) ? "" : this.getRoundedDate(15, new Date(value.ClockOut));

                            let roundedClockIn = moment(new Date(actualClockIn)).format("hh:mm a");
                            let roundedClockOut = (actualClockOut == "") ? "" : moment(new Date(actualClockOut)).format("hh:mm a");

                            let getRoundedHours = moment.duration(moment(new Date(date + " " + roundedClockOut)).diff(moment(new Date(date + " " + roundedClockIn) ))).asHours()
                            let rounded = null;

                            if (getRoundedHours < 0) {
                                rounded = moment.duration(moment(new Date(date + " " + roundedClockOut)).add(1, 'days').diff(moment(new Date(date + " " + roundedClockIn) ))).asHours()
                                
                            } else {
                                rounded = getRoundedHours
                            }

                            value.regular = (rounded > 8) ? 8 : rounded;
                            this.upperHeader[9].value = this.upperHeader[9].value + parseFloat(value.regular); // sums the regular hours

                            value.overtime = (rounded > 8) ? rounded - 8 : 0;
                            this.upperHeader[11].value = this.upperHeader[11].value + parseFloat(value.overtime); // sums the overtime hours

                            // totalTimeFull = (actualClockOut == "") ? 0 : moment(new Date(actualClockOut)).diff(moment(new Date(actualClockIn)));
                            // let hours = moment.duration(totalTimeFull).hours();
                            // let minutes = moment.duration(totalTimeFull).minutes() / 60;

                            value.total = rounded;
                            this.upperHeader[12].value = this.upperHeader[12].value + parseFloat(value.total); // sums the total hours

                            let parsedCost = (parseFloat(value.total)) * (parseFloat(value.Rate) || 0);
                            value.cost = parsedCost.toFixed(2);
                            this.upperHeader[14].value = this.upperHeader[14].value + parseFloat(parsedCost.toFixed(2)); // sums the cost

                            timesheets.push(value);
                        });
                    });

                    // Sort by Program (Ascending order)
                    timesheets.sort((a, b) => {
                        if (a.program < b.program) {
                            return -1;
                        }
                        if (a.program > b.program) {
                        return 1;
                        }
                    
                        // names must be equal
                        return 0;
                    })

                    // Sort by Staff/Employee (Ascending order)
                    timesheets.sort((a, b) => {
                        if (a.employee < b.employee) {
                            return -1;
                        }
                        if (a.employee > b.employee) {
                        return 1;
                        }
                    
                        // names must be equal
                        return 0;
                    })

                    let formattedTemplate = [];

                    let programTotalReg = 0, programTotalOT = 0, programTotalHours = 0, programTotalCost = 0;
                    let sliceStart;

                    timesheets[timesheets.length] = {};

                    timesheets.forEach((item, index) => {
                        index == 0 ? sliceStart = 0 : sliceStart;
            
                        if (timesheets[index+1] != timesheets[timesheets.length]) {
                            if (item.program == timesheets[index+1].program) {
                                programTotalReg = programTotalReg + parseFloat(item.regular);
                                programTotalOT = programTotalOT + parseFloat(item.overtime);
                                programTotalHours = programTotalHours + parseFloat(item.total);
                                programTotalCost = programTotalCost + parseFloat(item.cost)
                            } else {
                                programTotalReg = programTotalReg + parseFloat(item.regular);
                                programTotalOT = programTotalOT + parseFloat(item.overtime);
                                programTotalHours = programTotalHours + parseFloat(item.total);
                                programTotalCost = programTotalCost + parseFloat(item.cost)
                                
                                item.program = item.program + " Total";
                                item.regular = programTotalReg.toFixed(2);
                                item.overtime = programTotalOT.toFixed(2);
                                item.total = programTotalHours.toFixed(2);
                                item.cost = programTotalCost.toFixed(2);

                                formattedTemplate = formattedTemplate.concat(
                                    item
                                );
                                programTotalReg = 0;
                                programTotalOT = 0;
                                programTotalHours = 0;
                                programTotalCost = 0;
            
                                sliceStart = index+1;
                            }
                        } 
                    })

                    timesheets = formattedTemplate

                    // let totalReg = 0;
                    // let totalOverTime = 0;
                    // let totalTime = 0;
                    // let totalCost = 0;

                    // let mergedPrograms = [];
                    // let mergedClients = [];

                    // timesheets[timesheets.length] = {
                    //     _id: {
                    //         employeeID: ""
                    //     }
                    // }
                    
                    // timesheets = timesheets.filter((item, index) => {
                    //     if (timesheets[index+1] != timesheets[timesheets.length]) {
                    //         if (item._id.employeeID == timesheets[index+1]._id.employeeID) {
                    //             totalReg = totalReg + parseFloat(item.regular)
                    //             totalOverTime = totalOverTime + parseFloat(item.overtime)
                    //             totalTime = totalTime + parseFloat(item.total)
                    //             totalCost = totalCost + parseFloat(item.cost)

                    //             mergedPrograms = mergedPrograms.concat(item.program)
                    //             mergedClients = mergedClients.concat(item.ClientName)
                    //         } else {
                    //             totalReg = totalReg + parseFloat(item.regular)
                    //             totalOverTime = totalOverTime + parseFloat(item.overtime)
                    //             totalTime = totalTime + parseFloat(item.total)
                    //             totalCost = totalCost + parseFloat(item.cost)

                    //             mergedPrograms = mergedPrograms.concat(item.program)
                    //             mergedClients = mergedClients.concat(item.ClientName)

                    //             item.regular = totalReg.toFixed(2)
                    //             item.overtime = totalOverTime.toFixed(2)
                    //             item.total = totalTime.toFixed(2)
                    //             item.cost = "$" + totalCost.toFixed(2)

                    //             item.program = mergedPrograms.toString()
                    //             item.ClientName = mergedClients.toString()
                                
                    //             totalReg = 0
                    //             totalOverTime = 0
                    //             totalTime = 0
                    //             totalCost= 0
                                
                    //             mergedPrograms = []
                    //             mergedClients = []

                    //             return item
                    //         }
                    //     }
                    // })
                } catch (e) {
                    console.log(e)
                } finally {
                    this.upperHeader[9].value = this.upperHeader[9].value.toFixed(2);
                    this.upperHeader[11].value = this.upperHeader[11].value.toFixed(2);
                    this.upperHeader[12].value = this.upperHeader[12].value.toFixed(2);
                    this.upperHeader[14].value = this.upperHeader[14].value.toFixed(2);

                    this.timesheets = timesheets;
                    this.isLoadingConfirmedPayroll = false;
                }

            }
        },

        async getPayrollSplit() {
            if (this.SplitOvernight) {

                this.headers = [
                    /*{
                      text: 'UserId',
                      align: 'start',
                      sortable: false,
                      value: 'UserId',
                    },*/
                    {text: 'Employee', value: 'employee'},
                    {text: 'PaychexID', value: 'PaychexID'},
                    //{ text: 'EID', value: 'eid' },
                    {text: 'Shift Title', value: 'shiftTitle'},
                    {text: 'Position', value: 'position'},
                    {text: 'Program', value: 'program'},
                    {text: 'Client', value: 'ClientName'},
                    {text: 'Rate', value: 'rate'},
                    {text: 'Ratecard', value: 'rateCard'},
                    {text: 'Date', value: 'date'},
                    {text: 'Start time', value: 'startTime'},
                    {text: 'End Time', value: 'endTime'},
                    {text: 'Scheduled Start Time', value: 'scheduleClockIn'},
                    {text: 'Scheduled End Time', value: 'scheduleClockOut'},
                    {text: 'Actual Clock In Time', value: 'actualClockIn'},
                    {text: 'Actual Clock Out Time', value: 'actualClockOut'},
                    {text: 'Rounded Clock In Time', value: 'roundedClockIn'},
                    {text: 'Rounded Clock Out Time', value: 'roundedClockOut'},
                    {text: 'Regular', value: 'regular'},
                    {text: 'Special', value: 'special'},
                    {text: 'Overtime', value: 'overtime'},
                    {text: 'Total', value: 'total'},
                    {text: 'Tips', value: 'tip'},
                    {text: 'Cost', value: 'cost'},
                ];

                /*
                this.headers= [
                  {
                  text: 'UserId',
                  align: 'start',
                  sortable: false,
                  value: 'UserId',
                  },
                  { text: 'Employee', value: 'employee' },
                  { text: 'PaychexID', value: 'PaychexID' },
                  { text: 'EID', value: 'eid' },
                  { text: 'Date', value: 'date' },
                  { text: 'Shift Title', value: 'shiftTitle' },
                  { text: 'Position', value: 'position' },
                  { text: 'Program', value: 'program' },
                  { text: 'Client', value: 'ClientName' },
                  { text: 'Rate', value: 'rate' },
                  { text: 'Ratecard', value: 'rateCard' },
                  { text: 'Scheduled Start Time', value: 'scheduleClockIn' },
                  { text: 'Scheduled End Time', value: 'scheduleClockOut' },
                  { text: 'Actual Clock In Time', value: 'actualClockIn' },
                  { text: 'Actual Clock Out Time', value: 'actualClockOut' },
                  { text: 'Rounded Clock In Time', value: 'roundedClockIn' },
                  { text: 'Rounded Clock Out Time', value: 'roundedClockOut' },
                  { text: 'Regular', value: 'regular' },
                  { text: 'Special', value: 'special' },
                  { text: 'Overtime', value: 'overtime' },
                  { text: 'Total', value: 'total' },
                  { text: 'Tips', value: 'tip' },
                  { text: 'Cost', value: 'cost' },,
                ];
                */

                let timesheetSplit = [];

                this.timesheets.forEach(async (value) => {

                    console.log(value.ClockOut.length);

                    let clockoutDate = moment(new Date(value.ScheduleOut[0])).format("YYYY-MM-DD");
                    let clockinDate = moment(new Date(value.ScheduleIn[0])).format("YYYY-MM-DD");

                    if (clockoutDate != clockinDate) {
                        let clockInSchedFull = moment(moment(new Date(value.ScheduleIn[0])).format('YYYY-MM-DD HH:mm'));
                        let clockOutSchedFull = moment(moment(new Date(value.ScheduleOut[0])).format('YYYY-MM-DD hh:mm'));
                        let midnightDateSched = moment(moment(new Date(value.ScheduleOut[0])).format('YYYY-MM-DD 00:00'));

                        let splitInRegular = midnightDateSched.diff(clockInSchedFull);
                        let splitOutRegular = clockOutSchedFull.diff(midnightDateSched);
                        let regularIN = moment.duration(splitInRegular).hours() + ":" + Math.floor(moment.duration(splitInRegular).minutes());

                        let clockInFull = moment(moment(new Date(value.ClockIn)).format('YYYY-MM-DD HH:mm'));
                        let clockOutFull = moment(moment(new Date(value.ClockOut)).format('YYYY-MM-DD hh:mm'));
                        let midnightDate = moment(moment(new Date(value.ClockOut)).format('YYYY-MM-DD 00:00'));

                        let splitInTotal = midnightDate.diff(clockInFull);
                        let splitOutTotal = clockOutFull.diff(midnightDate);
                        let regularOUT = moment.duration(splitOutRegular).hours() + ":" + Math.floor(moment.duration(splitOutRegular).minutes());

                        let totalIN = (value.ClockOut == 0) ? 0 : moment.duration(splitInTotal).hours() + ":" + Math.floor(moment.duration(splitInTotal).minutes());
                        let costIN = (parseFloat(value.Rate[0]) * (parseFloat(splitInRegular) / 3600000)).toFixed(2);

                        let totalOUT = moment.duration(splitOutTotal).hours() + ":" + Math.floor(moment.duration(splitOutTotal).minutes());
                        let costOUT = (parseFloat(value.Rate[0]) * (parseFloat(splitOutRegular) / 3600000)).toFixed(2);

                        let row = {
                            position: value.position,
                            employee: value.employee,
                            ClientName: value.ClientName,
                            program: value.program,
                            PaychexID: value.PaychexID,
                            UserId: value.UserId,
                            rate: value.rate,
                            startTime: value.scheduleClockIn,
                            endTime: "mid night",
                            scheduleClockIn: value.scheduleClockIn,
                            scheduleClockOut: "mid night",
                            actualClockIn: value.actualClockIn,
                            actualClockOut: value.actualClockOut,
                            roundedClockIn: value.roundedClockIn,
                            roundedClockOut: value.roundedClockOut,
                            regular: regularIN,
                            total: totalIN,
                            cost: `$${costIN}`,
                            date: clockinDate,
                        };
                        timesheetSplit.push(row);

                        row = {
                            position: value.position,
                            employee: value.employee,
                            ClientName: value.ClientName,
                            program: value.program,
                            PaychexID: value.PaychexID,
                            UserId: value.UserId,
                            rate: value.rate,
                            startTime: "mid night",
                            endTime: value.scheduleClockOut,
                            scheduleClockIn: "mid night",
                            scheduleClockOut: value.scheduleClockOut,
                            actualClockIn: value.actualClockIn,
                            actualClockOut: value.actualClockOut,
                            roundedClockIn: value.roundedClockIn,
                            roundedClockOut: value.roundedClockOut,
                            regular: regularOUT,
                            total: totalOUT,
                            cost: `$${costOUT}`,
                            date: clockoutDate
                        };
                        timesheetSplit.push(row);
                    } else {
                        timesheetSplit.push(value);
                    }
                });
                this.timesheets = [];
                this.timesheets = timesheetSplit;
            } else {
                this.getConfirmedPayroll();
            }
        },

        downloadPayroll() {
            if (this.employee == null || this.employee == "") {
                this.employee = "All";
            }
            window.location.href = `${url}/payroll/downloadPayroll?Employee=${this.employee}&Program=${this.program}&Position=${this.position}&GroupEmployee=${this.radioGroup}&DateStart=${this.dateStart}&DateEnd=${this.dateEnd}&Timezone=${this.userTimezone}&userState=${this.state}&userRole=${this.userRole}`;
        },

        downloadWorkstream() {
            if (this.employee == null || this.employee == "") {
                this.employee = "All";
            }
            // window.location.href = `${url}/payroll/downloadPaychecks?Employee=${this.employee}&Program=${this.program}&Position=${this.position}&GroupEmployee=${this.radioGroup}&DateStart=${this.dateStart}&DateEnd=${this.dateEnd}&Timezone=${this.userTimezone}`;
            window.open(`${url}/customCompanyPayrolls/downloadPayroll?Employee=${this.employee}&Program=${this.program}&Position=${this.position}&GroupEmployee=${this.radioGroup}&DateStart=${this.dateStart}&DateEnd=${this.dateEnd}&Timezone=${this.userTimezone}&userState=${this.state}&userRole=${this.userRole}`, '_blank')
        },

        editItem(item) {
            this.editedIndex = this.timesheets.indexOf(item);
            this.editedItem = Object.assign(item);
        },

        closeItem() {
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300)
        },

        saveItem() {
            this.isLoadingSaveEditButton = true;

            let id = this.editedItem._id.id
            let clockOutDate = moment(new Date(this.editedItem.ScheduleOut[0])).format("YYYY-MM-DD");

            let req_body = {
                ClockIn: moment(this.editedItem.date + " " + this.editedItem.actualClockIn).format("YYYY-MM-DD hh:mm a"),
                ClockOut: moment(clockOutDate + " " + this.editedItem.actualClockOut).format("YYYY-MM-DD hh:mm a"),
                ClockInSchedule: this.editedItem.ScheduleIn[0]
            }
            
            let getHours = moment.duration(moment(new Date(req_body.ClockOut)).diff(moment(new Date(req_body.ClockIn)))).asHours()
            
            if (getHours < 0) {
                let snackbarText = "Clock out time must be greater than clock in time."
                this.callSnackBar(snackbarText, "error", false, false)
            } else {
                axios.put(`${url}/timeSheets/${id}`, req_body).then(() => {
                    setTimeout(() => {
                        this.editedItem = Object.assign({}, this.defaultItem);
                        this.editedIndex = -1;
                        
                        let snackbarText = "Edit item has been saved.";
                        this.callSnackBar(snackbarText, "success", true, true)

                        this.getConfirmedPayroll();
                    }, 300)
                }).catch(error => {
                    let snackbarText = error.response.data.text;
                    this.callSnackBar(snackbarText, "error", false, false)
                }).finally(() => {
                    this.isLoadingSaveEditButton = false;
                })
            }
            
        },

        callSnackBar (text, color, textProp, outlined) {
            this.snackbar = true;
            this.snackbarText = text;
            this.snackbarColor = color;
            this.snackbarTextProp = textProp;
            this.snackbarOutlined = outlined;
        }

    },

}
</script>
<style scoped>
>>> .edited-field input {
    width: 50px;
}
</style>
